export default __webpack_public_path__ + "static/media/expressjs.b15c9e4d.svg";